import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { strings } from '/imports/strings';
import { useMethod, useUser } from '/imports/hooks';
import { randomString } from '/imports/utils';
import { Button } from '/imports/ui/Button';
import { Page } from '/imports/ui/Page';
import { PageHeading } from '/imports/ui/PageHeading';
import { PageBody } from '/imports/ui/PageBody';
import { DataCatalog } from '/imports/ui/DataCatalog';
import { createActiveFilter } from '/imports/ui/ActiveFilter';
import { Input } from '/imports/ui/Input';
import { Account, Roles, listAccountsForOrg, updateAccount } from '/imports/api/accounts';

export const AccountsPage = () => {
  const user = useUser();
  const orgId = user?.orgId;
  const [adminRoleFilter, setAdminRoleFilter] = useState(false);
  const [accounts, loading] = useMethod(listAccountsForOrg, orgId);
  const [catalogKey, setCatalogKey] = useState(randomString());
  const ActiveFilter = useMemo(() => createActiveFilter<Account>(), []);
  const _adminRoleFilter = (a: Account) => adminRoleFilter ? a.roles?.includes(Roles.admin) : true;
  return (
    <Page className={`page${loading ? ' initializing' : ''}`} breadcrumbs={[{ path: '/accounts', label: strings.Accounts() }]}>
      <PageHeading
        left={<h1>{strings.Accounts()}</h1>}
        right={
          <div>
            <Link to={'/accounts/new'}><Button>{strings.New()}</Button></Link>
          </div>
        }
      />
      <PageBody>
        <DataCatalog<Account>
          key={catalogKey}
          data={accounts || []}
          updateMethod={updateAccount as any}
          columns={[
            { field: '_user', label: strings.Username(), render: (document) => <Link to={`/accounts/${document._id}`}>{document._user?.username}</Link> },
            { field: 'firstName', input: { type: Input } }, { field: 'lastName', input: { type: Input } },
            { field: 'email' }, { field: 'roles', render: (document) => (document.roles || []).join(', ') }
          ]}
          tools={
            <div className="filters">
              <span className="filters-label">{strings.Filters()}:</span>
              <Button className={adminRoleFilter ? 'primary' : 'tertiary'} onClick={() => setAdminRoleFilter(!adminRoleFilter)}>{strings.Admin()}</Button>
              <ActiveFilter.Component onChange={() => setCatalogKey(randomString())} />
            </div>
          }
          filters={[ActiveFilter.filter(), _adminRoleFilter]}
          loading={loading}
        />
      </PageBody>
    </Page>
  );
};